import Sws from '@/auth/sws'
import type { CheckoutSws } from '@/auth/sws'
import type { SwsConfiguration } from '@serato/sws-sdk'
import type { App } from 'vue'

export default {
  install: (app: App) => {
    app.provide('$swsSdk', getSwsSdk())
  }
}

function getSwsSdk (): CheckoutSws {
  const config: SwsConfiguration = {
    appId: import.meta.env.VITE_APP_SWS_APP_ID ?? '',
    serviceUri: {
      id: import.meta.env.VITE_APP_SWS_SERVICE_URI_ID,
      license: import.meta.env.VITE_APP_SWS_SERVICE_URI_LICENSE,
      ecom: import.meta.env.VITE_APP_SWS_SERVICE_URI_ECOM,
      profile: import.meta.env.VITE_APP_SWS_SERVICE_URI_PROFILE,
      da: import.meta.env.VITE_APP_SWS_SERVICE_URI_DA,
      notifications: import.meta.env.VITE_APP_SWS_SERVICE_URI_NOTIFICATIONS,
      rewards: import.meta.env.VITE_APP_SWS_SERVICE_URI_REWARDS,
      aiproxy: import.meta.env.VITE_APP_SWS_SERVICE_URI_AI_PROXY,
      cloudlib: import.meta.env.VITE_APP_SWS_SERVICE_URI_CLOUDLIB
    },
    timeout: 30000
  }
  const sws = new Sws(config, window.localStorage)
  return sws
}